"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.microFrontends = void 0;
var microFrontends_1 = require("../types/microFrontends");
var teams_1 = require("./teams");
/**
 * The list of registered microfrontends.
 */
exports.microFrontends = {
    auth: {
        owner: teams_1.Team.WEB_CORE,
        description: 'The auth microfrontend handles the login and logout pages. It also visually blocks all other pages as long as a user is not logged in.',
        mountPoint: microFrontends_1.MicroFrontendMountPoint.CORE,
        routes: [{ path: 'login' }, { path: 'logout' }],
        mountAlways: true,
        loader: microFrontends_1.MicroFrontendLoader.GENERIC,
    },
    core: {
        owner: teams_1.Team.WEB_CORE,
        description: 'The core microfrontend handles core functions and exposes utilities to be used by other microfrontends.',
        mountPoint: microFrontends_1.MicroFrontendMountPoint.CORE,
        mountAlways: true,
        routes: [{ path: 'syntea-native' }],
        loader: microFrontends_1.MicroFrontendLoader.NONE,
        deploymentUrls: {
            bundle: { main: 'dist/bundle/js/app.js' },
        },
    },
    'static-pages': {
        owner: teams_1.Team.WEB_CORE,
        description: 'The static pages microfrontend renders static pages like data-privacy and imprint from given word-documents.',
        routes: [{ path: 'data-privacy' }, { path: 'legal' }],
    },
    'dev-overlay': {
        owner: teams_1.Team.WEB_CORE,
        description: 'The dev overlay microfrontend provides developer tooling that allows owners to work on the myCampus 2.0 platform more easily.',
        mountPoint: microFrontends_1.MicroFrontendMountPoint.GLOBAL,
        mountAlways: true,
        routes: [],
        loader: microFrontends_1.MicroFrontendLoader.NONE,
        developmentOnly: true,
    },
    navbar: {
        owner: teams_1.Team.WEB_CORE,
        description: 'The navbar microfrontend renders the navigation.',
        mountPoint: microFrontends_1.MicroFrontendMountPoint.NAVIGATION,
        routes: [{ path: 'error' }],
        mountAlways: true,
        loader: microFrontends_1.MicroFrontendLoader.NONE,
    },
    dashboard: {
        owner: teams_1.Team.WEB_CORE,
        description: 'The dashboard microfrontend renders the dashboard.',
        routes: { path: 'home' },
    },
    news: {
        owner: teams_1.Team.WEB_CORE,
        description: 'The news microfrontend renders the news page.',
        routes: { path: 'news' },
    },
    directories: {
        owner: teams_1.Team.WEB_CORE,
        description: 'The directories microfrontend contains multiple overview pages: faq, info-center, community and study-management.',
        routes: [
            { path: 'community', exact: true },
            { path: 'examination' },
            { path: 'faq' },
            { path: 'info-center' },
            { path: 'lectures' },
            { path: 'study-management', exact: true },
            { path: 'schedule' },
        ],
    },
    profile: {
        owner: teams_1.Team.WEB_CORE,
        description: 'The profile microfrontend renders the profile page.',
        routes: { path: 'profile' },
    },
    'student-calendar': {
        owner: teams_1.Team.WEB_CORE,
        description: 'The student calendar microfrontend renders the calendar page.',
        routes: { path: 'calendar' },
    },
    'student-service-desk': {
        owner: teams_1.Team.WEB_CORE,
        description: 'The student service desk microfrontend renders the student service desk page.',
        routes: [
            { path: 'study-management/student-service-desk' },
            { path: 'contact' },
        ],
    },
    learn: {
        owner: teams_1.Team.ROCKET,
        description: 'The learn microfrontend renders the learn page.',
        routes: { path: 'learn' },
        providesWidgets: true,
    },
    exam: {
        owner: teams_1.Team.OKEANOS,
        description: 'The exam microfrontend renders the exam page.',
        routes: { path: 'study-management/examinations' },
    },
    gradeview: {
        owner: teams_1.Team.KRONOS,
        description: 'The gradeview microfrontend renders the gradeview page.',
        routes: { path: 'study-management/gradeview' },
    },
    'study-plan': {
        owner: teams_1.Team.KRONOS,
        description: 'The study plan microfrontend renders the study plan page.',
        routes: { path: 'study-management/study-plan' },
    },
    'student-document': {
        owner: teams_1.Team.ATLAS,
        description: 'students can download study related certificates in self service.',
        routes: { path: 'study-management/documents' },
    },
    'user-experience-and-feedback': {
        owner: teams_1.Team.WEB_CORE,
        description: 'The user experience and feedback microfrontend.',
        mountPoint: microFrontends_1.MicroFrontendMountPoint.GLOBAL,
        mountAlways: true,
        routes: [],
        loader: microFrontends_1.MicroFrontendLoader.NONE,
    },
    'student-mentorship': {
        owner: teams_1.Team.WEB_CORE,
        description: 'Used by student to become or search for a mentor.',
        routes: { path: 'community/mentor' },
    },
    payment: {
        owner: teams_1.Team.THEIA,
        description: 'The payment microfrontend renders the payment page.',
        routes: { path: 'payment' },
    },
};
